import React, { useState, useEffect } from "react";
import { Avatar, Menu, Typography, Switch, Button } from "antd";
import icon from "../images/cryptocurrency.png";
import {
  HomeOutlined,
  FundOutlined,
  MoneyCollectOutlined,
  BulbOutlined,
  MenuOutlined,
} from "@ant-design/icons";
import { Link } from "react-router-dom";
import MenuItem from "antd/es/menu/MenuItem";
export default function Navbar(props) {
  const [theme, setTheme] = useState("dark");
  const [activeMenu, setActiveMenu] = useState(true);
  const [screenSize, setScreenSize] = useState(null);

  useEffect(() => {
    const handleResize = () => setScreenSize(window.innerWidth);
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (screenSize < 768) {
      setActiveMenu(false);
    } else {
      setActiveMenu(true);
    }
  }, [screenSize]);

  const handleClick = () => {
    props.onChange();
    setTheme("light");
  };

  return (
    <>
      <div className="nav-container">
        <div className="logo-container">
          <Avatar src={icon} size="large" />
          <Typography.Title level={2} className="logo">
            <Link to="/">CryptoHub</Link>
          </Typography.Title>
          <Button
            className="menu-control-container"
            onClick={() => setActiveMenu(!activeMenu)}
          >
            <MenuOutlined />
          </Button>
        </div>
        <Switch
          onChange={handleClick}
          checkedChildren="Dark"
          unCheckedChildren="Light"
        />
        <br />
        <br />
        {activeMenu && (
          <Menu theme="dark">
            <MenuItem key="1" icon={<HomeOutlined />}>
              <Link to="/">Home</Link>
            </MenuItem>
            <MenuItem key="2" icon={<FundOutlined />}>
              <Link to="/cryptocurrencies">Cryptocurrencies</Link>
            </MenuItem>
            <MenuItem key="3" icon={<MoneyCollectOutlined />}>
              <Link to="/exchanges">Exchanges</Link>
            </MenuItem>
            <MenuItem key="4" icon={<BulbOutlined />}>
              <Link to="/news">News</Link>
            </MenuItem>
          </Menu>
        )}
        <div className="blank"></div>

        {/*<div className="logo-container-user">
          <div>
            <Avatar
              size="large"
              className="avatar-img"
              style={{ backgroundColor: "#fde3cf", color: "#f56a00" }}
            >
              P
            </Avatar>
          </div>
          <div className="bio">
            <h3 className="user-details">PREJITH P</h3>
            <h5 className="user-details">
              <i>prejithp2002@gmail.com</i>
            </h5>
          </div>
        </div>
        */}

        {/*<Switch
          checked={theme === "dark"}
          onChange={changeTheme}
          checkedChildren="Dark"
          unCheckedChildren="Light"
        />
        <br />
        <br />
        <Menu theme={theme} onClick={onClick}>
          <MenuItem key="1" icon={<HomeOutlined />}>
            <Link to="/">Home</Link>
          </MenuItem>
          <MenuItem key="2" icon={<FundOutlined />}>
            <Link to="/cryptocurrencies">Cryptocurrencies</Link>
          </MenuItem>
          <MenuItem key="3" icon={<MoneyCollectOutlined />}>
            <Link to="/exchanges">Exchanges</Link>
          </MenuItem>
          <MenuItem key="4" icon={<BulbOutlined />}>
            <Link to="/news">News</Link>
          </MenuItem>
  </Menu>*/}
      </div>
    </>
  );
}
